import { observer } from 'mobx-react-lite'
import { type SchedulePeriodStore } from 'shared/ui/Schedule/ui/SchedulePeriod/store/SchedulePeriodStore'
import { Dropdown, type IDropdownItem, type IDropdownProps } from 'shared/ui'
import {
  type ISchedulePeriod,
  schedulePeriods,
  schedulePeriodTitle,
} from 'shared/ui/Schedule/ui/SchedulePeriod/store/types'
import { makeTextFieldIcon, TextFieldPlaceholder } from 'shared/ui/TextField'
import styles from './styles.module.scss'

export type ISchedulePeriodProps = {
  store: SchedulePeriodStore
  excludePeriods?: ISchedulePeriod[]
} & Omit<IDropdownProps, 'items' | 'onSelectValue' | 'value'>

export const SchedulePeriod = observer(
  ({ store, excludePeriods = [], ...props }: ISchedulePeriodProps) => {
    const { period, setPeriod } = store

    const items: IDropdownItem[] = schedulePeriods
      .filter((period) => !excludePeriods.includes(period))
      .map((item) => ({
        id: item,
        label: schedulePeriodTitle[item],
        activeValue: period === item,
      }))
    const onChange = (item: IDropdownItem) => {
      setPeriod(item.id as ISchedulePeriod)
    }
    return (
      <Dropdown
        className={styles.wrap}
        items={items}
        onChange={onChange}
        margin={0}
        triggerComponent={() => (
          <TextFieldPlaceholder
            variant={'outline'}
            size={'small'}
            rightActions={[
              makeTextFieldIcon({
                icon: 'chevronDown',
                color: 'var(--content-neutral-primary)',
              }),
            ]}
            placeholder={schedulePeriodTitle[period]}
          />
        )}
        PopperProps={{
          modifiers: [
            {
              name: 'offset',
              options: {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                offset: ({ reference }) => {
                  return [0, -reference.height - 4]
                },
              },
            },
          ],
        }}
        {...props}
      />
    )
  }
)
